import {
  Landmark,
  Wallet,
  CreditCard,
  ArrowLeftRight,
  Send,
  Braces,
  Layers,
  Store,
  Car,
  Code2,
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Plattform", href: "#plattform" },
  { label: "Funktionen", href: "#funktionen" },
  { label: "Für Unternehmen", href: "#unternehmen" },
  { label: "API", href: "#api" },
  { label: "Kontakt", href: "#kontakt" },
];

export const TRUST_ITEMS = [
  "White Label",
  "API First",
  "Multi-Currency",
  "Compliance Ready",
  "SEPA & SWIFT",
  "PCI-DSS Level 1",
  "Echtzeit-Ledger",
];

export const FEATURES = [
  {
    id: "01",
    icon: Landmark,
    title: "Geschäftskonten",
    desc: "Dedizierte IBANs, Sub-Ledger und Multi-Entity-Strukturen. Vollständig programmierbar über eine einzige Schnittstelle.",
  },
  {
    id: "02",
    icon: Wallet,
    title: "Wallets",
    desc: "Multi-Currency-Wallets mit Echtzeit-Salden, Ledger-Logik und automatisierten Kontenmodellen für jede Nutzergruppe.",
  },
  {
    id: "03",
    icon: CreditCard,
    title: "Karten",
    desc: "Physische und virtuelle Karten mit White-Label-Design, granularen Limits und Just-in-Time-Funding.",
  },
  {
    id: "04",
    icon: ArrowLeftRight,
    title: "Payments",
    desc: "Ein- und ausgehende Zahlungen über SEPA, SWIFT und Instant. Orchestriert über eine deterministische Payment-Engine.",
  },
  {
    id: "05",
    icon: Send,
    title: "Auszahlungen",
    desc: "Massen- und Einzelauszahlungen mit Freigabe-Workflows, Reconciliation und lückenloser Nachvollziehbarkeit.",
  },
  {
    id: "06",
    icon: Braces,
    title: "API",
    desc: "REST-first, ereignisgetrieben und vollständig dokumentiert. Webhooks, Sandbox und SDKs für schnelle Integration.",
  },
];

export const AUDIENCES = [
  {
    icon: Layers,
    title: "Plattformen",
    desc: "Embedded Finance für Marktplätze und SaaS-Plattformen – Konten, Zahlungen und Auszahlungen nativ integriert.",
  },
  {
    icon: Store,
    title: "Händlernetzwerke",
    desc: "Zentralisierte Abrechnung, Settlement und Liquiditätssteuerung über verteilte Filial- und Partnerstrukturen.",
  },
  {
    icon: Car,
    title: "Automotive-Unternehmen",
    desc: "Fahrzeug-, Flotten- und Händlerfinanzierung mit programmierbaren Konten und automatisierten Zahlungsflüssen.",
  },
  {
    icon: Code2,
    title: "Softwareanbieter",
    desc: "White-Label-Banking als Produktfunktion – ausgeliefert unter Ihrer Marke, betrieben auf unserer Infrastruktur.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Infrastruktur statt Insellösung",
    desc: "CashFUX ist kein weiteres Payment-Tool. Es ist die durchgängige Schicht zwischen Ihrem Produkt und dem regulierten Finanzsystem.",
  },
  {
    no: "02",
    title: "API First, nicht API irgendwann",
    desc: "Jede Funktion existiert zuerst als Schnittstelle. Was das Dashboard kann, kann auch Ihr Code – deterministisch und dokumentiert.",
  },
  {
    no: "03",
    title: "Ihre Marke im Vordergrund",
    desc: "White Label bedeutet bei uns vollständig. Ihre Kunden sehen Ihr Produkt – wir bleiben unsichtbare Infrastruktur.",
  },
];
